import ProductItem from '../components/product/ProductItem';
import quickShop from '../components/product/ProductQuickShop';

const selectors = {
  quickShopTrigger: '[data-quickshop-trigger]',
};

export default class Collection {
  constructor(section) {
    const productItems = section.el.querySelectorAll('[data-product-item]');
    [...productItems].forEach(productItem => {
      new ProductItem(productItem);
    });

    this._checkForProductList();
  }

  _checkForProductList = () => {
    if (typeof ProductList === 'undefined') {
      setTimeout(this._checkForProductList, 50); //wait 50 millisecnds then recheck
      return;
    }
    this._initQuickShop();
    //real action
  };

  _initQuickShop() {
    ProductList.prototype.afterRender = function () {
      this.data.forEach(product => {
        const productItem = document.querySelector(`[data-id="${product.id}"]`);
        const trigger = productItem.querySelector(selectors.quickShopTrigger);

        if (!trigger) {
          return;
        }

        trigger.addEventListener('click', () => {
          const { productUrl } = productItem.dataset;

          quickShop.open(productUrl);
        });
      });
    };
  }
}
